export const confirmCampaignPlanUrl = "/api/v3/confirm/campaign/:campaignId";
export const addSellerMediaToCampaignUrl =
  "/api/v3/confirm/campaign/:campaignId/media";
